import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-176">
      <div className="max-w-3xl mx-auto" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-178">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-179">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border" data-id="element-180">
            It's Sunday night. It's 10pm. You have a Jazz class tomorrow
            morning, a Contemporary session in the afternoon, and a Musical
            Theatre group at 6pm.
            <br data-id="element-181" />
            <br data-id="element-182" />
            And you're still here — searching through old notes, scrolling
            through videos, trying to piece together a warm-up that flows, a
            technical sequence that actually builds somewhere, and a combination
            your intermediate students haven't already done six times this term.
            <br data-id="element-183" />
            <br data-id="element-184" />
            <span className="text-gold-light font-medium" data-id="element-185">
              Not because you don't know how to teach dance.
            </span>{' '}
            Because no one ever gave you a complete, ready-to-use teaching
            library. You've been building every single class from scratch. The
            time you should be resting — you're spending it planning. The mental
            energy you should be saving for your students — you're burning it
            before you even walk through the studio door.
            <br data-id="element-186" />
            <br data-id="element-187" />
            And the worst part isn't the exhaustion. The worst part is walking
            in and feeling like you could have been more prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-188">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-189">
            The Real Cost of Not Having the Right Resource
          </h3>

          <ul className="space-y-4" data-id="element-190">
            {['Nights lost searching for drills, combinations, and warm-ups that actually work for your specific students', 'Classes that feel repetitive — because you keep returning to the same exercises you already know', 'Visible improvisation that quietly chips away at your confidence as a teacher', 'No real technical progression across weeks — and students who slowly lose motivation without knowing why', 'Weekends spent planning instead of resting, recovering, or living your life outside the studio'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/30" data-id="element-191">
                <span className="text-red-500 mt-1" data-id="element-192">🔴</span>
                <span className="text-gray-300" data-id="element-193">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-194">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-195">
              Stop giving away your free time. Your dedication is already there.
              What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-196">
              Plan more than 40 weeks of classes — today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}